import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import EditIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";

import { BILLING_LEDGER_ENTRIES_PATH } from "../../../constants/router";

export const headRows = translate => [
  { id: "conferenceId", numeric: false, disablePadding: true, label: translate.conferenceId },
  { id: "startTime", numeric: false, disablePadding: false, label: translate.confStartTime },
  { id: "endTime", numeric: false, disablePadding: false, label: translate.confEndTime },
  { id: "quantity", numeric: true, disablePadding: false, label: translate.quantity },
  { id: "name", numeric: false, disablePadding: false, label: translate.name },
  { id: "requestFrom", numeric: false, disablePadding: false, label: translate.requestFrom },
  { id: "userName", numeric: false, disablePadding: false, label: translate.participantName },
  { id: "bPhoneNo", numeric: false, disablePadding: false, label: translate.bPhoneNumber },
  { id: "contractNo", numeric: false, disablePadding: false, label: translate.contractNumber },
  { id: "stat", numeric: false, disablePadding: false, label: translate.status },
  { id: "errorCode", numeric: false, disablePadding: false, label: translate.errorCodeLedgerEntry },
];

const useStyles = makeStyles(theme => ({
  actions: {
    minWidth: "100px",
    padding: "5px",
  },
  edit: {
    margin: theme.spacing(0, 1),
    maxHeight: "48px",
  },
  small: {
    padding: "5px",
  },
}));

const BillingLedgerEntryTableRowTableRow = ({ row, isItemSelected, labelId, handleClick }) => {
  const classes = useStyles();
  return (
    <TableRow hover role="checkbox" aria-checked={isItemSelected} tabIndex={-1} selected={isItemSelected}>
      <TableCell className={classes.actions} padding="checkbox">
        <Checkbox
          onClick={event => handleClick(event, row.selectIndex)}
          checked={isItemSelected}
          inputProps={{ "aria-labelledby": labelId }}
        />
        <NavLink style={{ color: "inherit", textDecoration: "none" }} to={`${BILLING_LEDGER_ENTRIES_PATH}/${row.id}`}>
          <IconButton className={classes.edit}>
            <EditIcon />
          </IconButton>
        </NavLink>
      </TableCell>
      <TableCell /* component="th" */ id={labelId} scope="row" padding="none">
        {row.conferenceId}
      </TableCell>
      <TableCell className={classes.small} align="right">
        {row.startTimeString}
      </TableCell>
      <TableCell className={classes.small} align="right">
        {row.endTimeString}
      </TableCell>
      <TableCell className={classes.small} align="right">
        {row.quantity}
      </TableCell>
      <TableCell className={classes.small} align="right">
        {row.name}
      </TableCell>
      <TableCell className={classes.small} align="right">
        {row.requestFrom}
      </TableCell>
      <TableCell className={classes.small} align="right">
        {row.userName}
      </TableCell>
      <TableCell className={classes.small} align="right">
        {row.bPhoneNo}
      </TableCell>
      <TableCell className={classes.small} align="right">
        {row.contractNo}
      </TableCell>
      <TableCell className={classes.small} align="right">
        {row.stat}
      </TableCell>
      <TableCell className={classes.small} align="right">
        {row.errorCode}
      </TableCell>
    </TableRow>
  );
};

BillingLedgerEntryTableRowTableRow.propTypes = {
  row: PropTypes.object.isRequired,
  isItemSelected: PropTypes.bool.isRequired,
  labelId: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default BillingLedgerEntryTableRowTableRow;
